import { PropTypes } from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { HandleClickOutside } from '../../../../common/HandleClickOutside'
import { Dropdown, positionDropdown } from '../../../../common/dropdown'
import useDidUpdateEffect from '../../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { ScrollComponent } from '../../../../common/scrollComponent'

export const InputSearchDropdown = ({
  renderElement,
  renderDropdown,
  isToggleOnClick,
  isDropdownFollowWidth,
  onToggleShowDropdown,
  allowShowDropdown,
  wrapperClassName,
  dropdownItemHeight,
  dropdownClassName,
  dropdownStyle,
  dropdownPosition,
  appendStyleDropDown,
  isDisplayDropdown,
  data,
  style,
  isLoading,
  handleClearText,
  actionAfterHiddenDrop,
  renderNodata,
  dropdownStyleNoData,
  isValidateTwoKey,
  textInput,
}) => {
  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const elementRef = useRef()

  const showDropdown = () => {
    setIsShowDropdown(true)
  }

  const hideDropdown = () => {
    setIsShowDropdown(false)
  }

  const toggleShowDropdown = () => {
    setIsShowDropdown((prev) => !prev)
  }

  useEffect(() => {
    onToggleShowDropdown && onToggleShowDropdown(isShowDropdown)
  }, [isShowDropdown])

  const dropdownHeight = dropdownItemHeight
    ? data?.length * dropdownItemHeight
    : null

  const position =
    dropdownPosition || dropdownHeight
      ? window.innerHeight -
          elementRef.current?.getBoundingClientRect()?.bottom <
        dropdownHeight
        ? positionDropdown.TOP_LEFT_RIGHT
        : positionDropdown.BOTTOM_LEFT_RIGHT
      : positionDropdown.BOTTOM_LEFT_RIGHT

  useEffect(() => {
    const hideDropdown = () => setIsShowDropdown(false)

    const scrollElement = document.querySelector(
      `#MainContent .scrollbars div:first-child`,
    )

    window.addEventListener('resize', hideDropdown)
    if (scrollElement) {
      scrollElement.addEventListener('scroll', hideDropdown)
    }

    return () => {
      window.removeEventListener('resize', hideDropdown)
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', hideDropdown)
      }
    }
  }, [])

  useEffect(() => {
    if (isDisplayDropdown) {
      setIsShowDropdown(true)
    }
  }, [isDisplayDropdown])

  useEffect(() => {
    handleClearText && handleClearText()
  }, [isShowDropdown])

  useDidUpdateEffect(() => {
    if (!isShowDropdown) {
      actionAfterHiddenDrop && actionAfterHiddenDrop()
    }
  }, [isShowDropdown])

  useEffect(() => {
    const handleKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        setIsShowDropdown(false)
      }
    }
    document.addEventListener('keydown', handleKeydown)

    return () => {
      document.removeEventListener('keydown', handleKeydown)
    }
  }, [])

  return (
    <>
      <Element
        ref={elementRef}
        className={wrapperClassName}
        onClick={isToggleOnClick ? toggleShowDropdown : showDropdown}
        style={{ ...style }}
      >
        {renderElement({ isShowDropdown, showDropdown, hideDropdown })}
      </Element>
      {isLoading && isShowDropdown ? (
        <Dropdown
          parentRef={elementRef}
          position={positionDropdown.BOTTOM_START_RIGHT}
          zIndex={13}
        >
          <Element
            className={dropdownClassName}
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: 4,
              padding: '4px 0px',
              overflow: 'hidden',
              width: isDropdownFollowWidth
                ? elementRef?.current?.offsetWidth
                : undefined,
              minWidth: !isDropdownFollowWidth
                ? elementRef?.current?.offsetWidth
                : undefined,
              maxWidth: !isDropdownFollowWidth ? 600 : undefined,
              height: 40,
              ...dropdownStyle,
            }}
          >
            <Loading />
          </Element>
        </Dropdown>
      ) : (
        <>
          {allowShowDropdown && !!data?.length && isShowDropdown && (
            <Dropdown
              parentRef={elementRef}
              position={positionDropdown.BOTTOM_START_RIGHT}
              appendStyle={appendStyleDropDown}
              zIndex={13}
            >
              <HandleClickOutside
                handleClickOutside={hideDropdown}
                exceptRef={elementRef}
              >
                <>
                  {textInput.length === 1 && isValidateTwoKey ? (
                    <>
                      <Element
                        className={dropdownClassName}
                        style={{
                          backgroundColor: '#FFFFFF',
                          borderRadius: 4,
                          padding: '4px 0px',
                          overflow: 'hidden',
                          width: isDropdownFollowWidth
                            ? elementRef.current.offsetWidth
                            : undefined,
                          minWidth: !isDropdownFollowWidth
                            ? elementRef.current.offsetWidth
                            : undefined,
                          maxWidth: !isDropdownFollowWidth ? 600 : undefined,
                          maxHeight: 400,
                          textAlign: 'center',
                          ...dropdownStyleNoData,
                        }}
                      >
                        <Element
                          style={{
                            fontStyle: 'italic',
                            padding: 12,
                            color: 'rgb(224, 80, 91)',
                          }}
                        >
                          <Translate value="library.main.LEAST2" />
                        </Element>
                      </Element>
                    </>
                  ) : (
                    <>
                      <>
                        {!data.length && renderNodata && <>{renderNodata()}</>}
                      </>
                      <Element
                        className={dropdownClassName}
                        style={{
                          backgroundColor: '#FFFFFF',
                          borderRadius: 4,
                          padding: '4px 0px',
                          overflow: 'hidden',
                          width: isDropdownFollowWidth
                            ? elementRef.current.offsetWidth
                            : undefined,
                          minWidth: !isDropdownFollowWidth
                            ? elementRef.current.offsetWidth
                            : undefined,
                          maxWidth: !isDropdownFollowWidth ? 600 : undefined,
                          ...dropdownStyle,
                        }}
                      >
                        {dropdownHeight ? (
                          <ScrollComponent autoHeight autoHeightMax={400}>
                            {renderDropdown({ hideDropdown, position })}
                          </ScrollComponent>
                        ) : (
                          renderDropdown({ hideDropdown, position })
                        )}
                      </Element>
                    </>
                  )}
                </>
              </HandleClickOutside>
            </Dropdown>
          )}
          {allowShowDropdown &&
            renderNodata &&
            !data?.length &&
            isShowDropdown && (
              <Dropdown
                parentRef={elementRef}
                position={positionDropdown.BOTTOM_START_RIGHT}
                appendStyle={appendStyleDropDown}
                zIndex={13}
              >
                <HandleClickOutside
                  handleClickOutside={hideDropdown}
                  exceptRef={elementRef}
                >
                  <Element
                    className={dropdownClassName}
                    style={{
                      backgroundColor: '#FFFFFF',
                      borderRadius: 4,
                      padding: '4px 0px',
                      overflow: 'hidden',
                      width: isDropdownFollowWidth
                        ? elementRef.current.offsetWidth
                        : undefined,
                      minWidth: !isDropdownFollowWidth
                        ? elementRef.current.offsetWidth
                        : undefined,
                      maxWidth: !isDropdownFollowWidth ? 600 : undefined,
                      maxHeight: 400,
                      textAlign: 'center',
                      ...dropdownStyleNoData,
                    }}
                  >
                    {textInput.length === 1 && isValidateTwoKey ? (
                      <Element
                        style={{
                          fontStyle: 'italic',
                          padding: 12,
                          color: 'rgb(224, 80, 91)',
                        }}
                      >
                        <Translate value="library.main.LEAST2" />
                      </Element>
                    ) : (
                      <>{renderNodata()}</>
                    )}
                  </Element>
                </HandleClickOutside>
              </Dropdown>
            )}
        </>
      )}
    </>
  )
}

InputSearchDropdown.propTypes = {
  renderElement: PropTypes.func.isRequired,
  renderDropdown: PropTypes.func.isRequired,
  isToggleOnClick: PropTypes.bool,
  isDropdownFollowWidth: PropTypes.bool,
  onToggleShowDropdown: PropTypes.func,
  allowShowDropdown: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  dropdownItemHeight: PropTypes.number,
  maxDropdownItem: PropTypes.number,
  dropdownClassName: PropTypes.string,
  dropdownStyle: PropTypes.object,
  dropdownPosition: PropTypes.string,
  isDisplayDropdown: PropTypes.bool,
  data: PropTypes.any,
  isLoading: PropTypes.bool,
  style: PropTypes.object,
  renderNodata: PropTypes.func,
  dropdownStyleNoData: PropTypes.object,
  isValidateTwoKey: PropTypes.bool,
  textInput: PropTypes.string,
}

InputSearchDropdown.defaultProps = {
  renderElement: () => null,
  renderDropdown: () => null,
  isToggleOnClick: false,
  isDropdownFollowWidth: true,
  allowShowDropdown: true,
  wrapperClassName: '',
  dropdownClassName: '',
  dropdownStyle: {},
  positionDropdown: positionDropdown.BOTTOM_LEFT_RIGHT,
  maxDropdownItem: 10,
  isDisplayDropdown: false,
  data: [1],
  isLoading: false,
  style: { width: 'fit-content' },
  dropdownStyleNoData: {},
  isValidateTwoKey: false,
  textInput: '',
}
